var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.basketCount)?_c('div',{staticClass:"product-basket-count",class:{ 'product-info-basket-count-tag': _vm.lowerPosition  }},[_vm._v("\n    "+_vm._s(_vm.basketCount)),_c('i',{staticClass:"fa-regular fa-cart-shopping ms-2"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }